// REACT & Libraries
import { useEffect } from "react";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

// Role Guard
import RoleGuard from "../../RoleGuard";

// Components
import JobTitleContainer from "../../../Components/MasterData/JobTitle";

const JobTitle = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Job Title Master Data";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "data-master"]}
      />

      {/* Main content */}
      <JobTitleContainer />
    </>
  );
};

export default JobTitle;
